import {
  BOARD_X_START,
  BOARD_Y_START,
  CELL_HEIGHT,
  CELL_WIDTH
} from "../../../../config"

export const FIREBASE_CONFIG = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID
}

export const GITEE_CONFIG = {
  clientId: process.env.GITEE_CLIENT_ID,
  enable: process.env.GITEE_ENABLE !== "false", // 默认为true
  // baseUrl: process.env.GITEE_BASEURL,
  // redirectUri: process.env.GITEE_REDIRECT_URI,
  // clientSecret: process.env.GITEE_CLIENT_SECRET,
};

export const CASDOOR_CONFIG = {
  clientId: process.env.CASDOOR_CLIENT_ID,
  // baseUrl: process.env.CASDOOR_BASEURL,
  // redirectUri: process.env.CASDOOR_REDIRECT_URI,
  // clientSecret: process.env.CASDOOR_CLIENT_SECRET,
};

// export function transformCoordinate(x: number, y: number) {
// export function transformBoardCoordinates(x: number, y: number) { 
export function transformBoardCoordinates(
  x: number,
  y: number
): [number, number] {
  if (y === 0) {
    return [BOARD_X_START + CELL_WIDTH * x, BOARD_Y_START]
  } else {
    return [
      BOARD_X_START + CELL_WIDTH * x,
      BOARD_Y_START - CELL_HEIGHT * (y + 1) + CELL_HEIGHT / 2
    ]
  }
}

export function transformEntityCoordinates(
  x: number,
  y: number,
  flip: boolean
): [number, number] {
  return [
    BOARD_X_START + CELL_WIDTH * x,
    CELL_HEIGHT / 2 +
      (flip
        ? BOARD_Y_START + CELL_HEIGHT * (y - 7)
        : BOARD_Y_START - CELL_HEIGHT * (y + 2))
  ]
}

export function transformMiniGameXCoordinate(x: number) {
  return BOARD_X_START + x
}

export function transformMiniGameYCoordinate(y: number) {
  return BOARD_Y_START - y - CELL_HEIGHT * 1.5
}
